import { CommonModule, isPlatformBrowser } from '@angular/common';
import { Component, Inject, PLATFORM_ID, ViewChild  } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { TableModule, Table } from 'primeng/table';
import { RouterLink, Router } from '@angular/router';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { FormsModule } from '@angular/forms';

import { AuthService } from '../../../../services/auth.service';
import { PageTitleService } from '../../../../services/pagetitle.service';
import { TimesheetService } from '../../../../services/timesheet.service';
import { NotificationService } from '../../../../services/notification.service';
import { EncryptionService } from '../../../../services/encryption.service';
import { Base64UrlService } from '../../../../services/base64-url.service';
import { AdminService } from '../../../../services/admin.service';
import { HttpClient } from '@angular/common/http';

/*----Prime NG----*/
import { InputTextModule } from 'primeng/inputtext';
import { InputIconModule } from 'primeng/inputicon';
import { IconFieldModule } from 'primeng/iconfield';
import { AutoComplete } from 'primeng/autocomplete';
@Component({
  selector: 'app-admin-orderlist',
  standalone: true,
  imports: [CommonModule, TranslateModule, ButtonModule, TableModule, InputTextModule, InputIconModule, IconFieldModule, FormsModule,AutoComplete],
  providers: [Base64UrlService],
  templateUrl: './admin-orderlist.component.html',
  styleUrl: './admin-orderlist.component.css'
})
export class AdminOrderlistComponent {
  @ViewChild('dt2') dt2: any;
  userName: any;
  lang: any;
  contractList: any;
  monthDropdown: any;
  yearDropdown: any;
  userCode: any;
  // These hold filtered data
  visibleData: any[] = [];
  totalCount: number = 0;
  monthList: number[] = [];
  selectedMonth: number | null = null;
  selectedYear: number | null = null;
  dashboard_msg: string | null = null;
  msgType: string | null = null;

  
  dropDowndate: any;
  branchDropdown: any[] = [];
  customerDropdown: any[] = [];
  selectedBranch: any = '-1';
  selectedCustomer: any = '-1';
  selectedSystemId: string = '-1';
  selectedSupplierId: string = '-1';
  selectedDate: string = '';
  weekEndingDate: string = '';
  displayByCompany: boolean = false;
  isVisible: boolean = true;

  filteredBranchs: any[] = [];
  selectedBranchId: number = -1;
  nonSearchable: boolean = true;
  selectedCustomerId: number = -1;
  filteredCustomers: any[] = [];

  constructor(private auth: AuthService, private translate: TranslateService, private ts: TimesheetService, private as: AdminService, private en: EncryptionService, private pageTitle: PageTitleService, private http: HttpClient, private ns: NotificationService, @Inject(PLATFORM_ID) private platformId: Object) {
    if (typeof window !== 'undefined' && typeof localStorage !== 'undefined') {

      this.lang = (localStorage.getItem('site_lang') ? localStorage.getItem('site_lang') : 'en');
      // console.log(this.lang)
      translate.use(this.lang);
    }
  }

  ngOnInit() {
    this.userName = this.auth.getName();
    this.userCode = this.auth.getCode();
    this.pageTitle.setTitle('menu.orderlist');
    if (isPlatformBrowser(this.platformId)) {
      this.selectedYear = new Date().getFullYear();
      this.selectedMonth = new Date().getMonth();
      this.getYear();
      this.monthList = Array.from({ length: 12 }, (_, i) => i + 1);
      this.selectedBranch = { branchID: -1, branchName: this.translate.instant('All') };
      this.selectedCustomer = { customerID: -1, customerName: this.translate.instant('All') };
      this.getAssociates();
    }
  }

  getYear() {
    this.ns.getYearList()
      .subscribe({
        next: (resYearList: any) => {
          this.yearDropdown = resYearList.data;
          // this.searchContracts();
          // this.getAssociatesList('2025-07-01');
        },
        error: (err: any) => {
          if(err.status === 401) {
            this.auth.logout();
			      return;	
          }
        }
      });
  }

  getAssociates() {
    
    this.as.getBranches()
      .subscribe({
        next: (resBranchList: any) => {
          this.branchDropdown = resBranchList.data;
          // console.log(this.branchDropdown);
        },
        error: (err: any) => {
          if(err.status === 401) {
            this.auth.logout(); 
			      return	
          }
        }
      });
    
    // this.as.getCustomers()
    //   .subscribe({
    //     next: (resCustmomersList: any) => {
    //       this.customerDropdown = resCustmomersList.data;
    //       // console.log(this.customerDropdown);
    //     },
    //     error: (err: any) => {
    //       if(err.status === 401) {
    //         this.auth.logout();   
		// 	      return	
    //       }
    //     }
    //   });

  }

  getContractList(filterObj: any) {
    const dateFormat = this.selectedYear + "-" + this.selectedMonth;
    // this.as.getContract(filterObj)
        this.as.getGroupContract(filterObj)
      .subscribe({
        next: (res: any) => {
          if (res.status) {
            // this.contractList = res.data.map((item: any) => {
            //   return {
            //     ...item,
            //     jobOrderIdOrg: item.jobOrderID,
            //     jobOrderID: Base64UrlService.encode(this.en.encryptionAES(item.jobOrderID.toString()))
            //   }
            //   // this.applyEncryption();
            // }); 
            
            // this.contractList = res.data.map((supplier: any) => ({
            //   ...supplier,
            //   sectionDto: supplier.sectionDto.map((section: any) => ({
            //     ...section,
            //     jobOrderDtos: section.jobOrderDtos.map((job: any) => ({
            //       ...job,
            //       jobOrderIdOrg: job.jobOrderID,
            //       jobOrderID: Base64UrlService.encode(
            //         this.en.encryptionAES(job.jobOrderID.toString())
            //       )
            //     }))
            //   }))
            // }));
            this.contractList = res.data.map((supplier: any) => {
              const searchTextParts: string[] = [];
              searchTextParts.push(supplier.supplier);
              searchTextParts.push(supplier.customer);
              supplier.sectionDto.forEach((section: any) => {
                searchTextParts.push(section.sectionName);

                section.jobOrderDtos.forEach((job: any) => {
                  searchTextParts.push(
                    job.contractNo,
                    job.jobOrderIdOrg,
                    job.userName
                  );
                });
              });

              return {
                ...supplier,
                comSearchText: searchTextParts.join(' ').toLowerCase(),
                sectionDto: supplier.sectionDto.map((section: any) => ({
                  ...section,
                  jobOrderDtos: section.jobOrderDtos.map((job: any) => ({
                    ...job,
                    jobOrderIdOrg: job.jobOrderID,
                    jobOrderID: Base64UrlService.encode(
                      this.en.encryptionAES(job.jobOrderID.toString())
                    )
                  }))
                }))
              };
            });
            // this.totalCount = this.contractList.length;
            this.totalCount = this.contractList.reduce((supplierAcc: number, supplier: any) => {                  
                const sectionCount = supplier.sectionDto.reduce((sectionAcc: number, section: any) => {                    
                    return sectionAcc + (section.jobOrderDtos?.length || 0);
                }, 0);                
                // Add the total section count to the main supplier accumulator
                return supplierAcc + sectionCount;
            }, 0);
            
            this.updateVisibleData();
          }
        },
        error: (err: any) => {
          console.log(err);
          if (err.status == 401) {
            this.auth.logout();
			      return
          } else {

          }
        }
    })
  }

  getSupplierRowspan(supplier: any) {
    return supplier.sectionDto.reduce((sum: number, sec: any) => {
      return sum + sec.jobOrderDtos.length;
    }, 0);
  }

  getSectionRowspan(section: any) {
    return section.jobOrderDtos.length;
  }
  ngAfterViewInit(): void {
    // 
  }

  // fncCng(event: any, dateType: any) {
  //   // let dateFormat = this.getDateFromEvent(event);
  //   let date = event.target.value;
  //   if (dateType == 'year') {
  //     this.selectedYear = date;
  //   } else if (dateType == 'month') {
  //     this.selectedMonth = date;
  //   }
  //   this.searchContracts();
  // }

  searchContracts() {
    // console.log(this.selectedMonth)
    // console.log(this.selectedYear) 
     if (this.selectedCustomerId === undefined || this.selectedCustomerId === null) {
      this.selectedCustomerId = -1;
    }
    if (this.selectedBranchId === undefined || this.selectedBranchId === null) {
      this.selectedBranchId = -1;
    }
    const filters = {
      startDate: this.selectedYear + "-" + this.selectedMonth,      
      selectedCustomer: this.selectedCustomerId,
      selectedSupplierId: this.selectedSupplierId,
      selectedBranch: this.selectedBranchId
    }
    this.getContractList(filters);
  }

  clearAll() {
    this.selectedYear = new Date().getFullYear();
    this.selectedMonth = new Date().getMonth();
    // this.selectedCustomer = '-1';
    // this.selectedBranch = '-1';
    this.selectedCustomer = { customerID: -1, customerName: this.translate.instant('All') };
    this.selectedBranch = { branchID: -1, branchName: this.translate.instant('All') };
    this.totalCount = 0;
    this.displayByCompany = true;
    this.nonSearchable = true;
    this.contractList = [];
    // this.searchContracts()
  }

  applyFilterGlobal($event: Event) {
    const input = $event.target as HTMLInputElement;
    this.dt2.filterGlobal(input.value, 'contains');
    // Table triggers onFilter after this
  }

  // Update filteredData whenever filter or pagination changes
  onFilter(event: any) {
    this.updateVisibleData();
  }

  onPage(event: any) {
    this.updateVisibleData(event);
  }

  onSort() {
    this.updateVisibleData();
  }

  updateVisibleData(event?: any) {
    const filtered = this.dt2.filteredValue ?? this.contractList??[];
    const start = event?.first ?? this.dt2.first ?? 0;
    const rows = event?.rows ?? this.dt2.rows ?? 3;
    const end = start + rows;
    this.visibleData = filtered.slice(start, end);
  }

  onGlobalFilter(event: Event) {
    const value = (event.target as HTMLInputElement).value;
    this.dt2.filterGlobal(value, 'contains');
    setTimeout(() => {
    this.totalCount = this.dt2.filteredValue
      ? this.dt2.filteredValue.length
      : this.dt2.value.length; // fallback to total rows if no filter applied
  });
  }

  applyEncryption(dt: any) {
      dt.forEach((elm: any, ind: any) => {
        dt[ind].jobOrderID = Base64UrlService.encode(this.en.encryptionAES(elm.jobOrderID.toString()))
      });
      return dt;
  }

  reset() {
    this.dashboard_msg = null;
  }

  filterBranch(event: any) {
    var query = event.query.toLowerCase();
    
    let list = [
      { branchId: -1, branchName: this.translate.instant('All') },
      ...this.branchDropdown
    ];
    if (!query) {
      this.filteredBranchs = list;
      return;
    }
    this.filteredBranchs = list.filter(c =>
      c.branchName.toLowerCase().includes(query)
    );
  }
  onSelectBranch(event: any) {
    console.log(event.value.branchId);
    this.selectedBranchId = event.value.branchId;
    if (this.selectedBranchId > 0) { 
      console.log("not all")
      this.as.getCustomersByBranch(this.selectedBranchId)
        .subscribe({
          next: (resCustmomersList: any) => {
            this.customerDropdown = resCustmomersList.data??[];
            console.log(this.customerDropdown);
            this.nonSearchable = false;
          },
          error: (err: any) => {
            if(err.status === 401) {
              this.auth.logout();    
              return	
            }
          }
        });
    } else {
      this.customerDropdown = [];
      this.nonSearchable = true;
    }
      // return
      
    // }
  }
  
  filterCustomer(event: any) {
    const query = (event.query || '').toLowerCase();//event.query.toLowerCase();
    const list = [
      { customerId: -1, customerName: this.translate.instant('All') },
      ...this.customerDropdown
    ];
    if (!query) {
      this.filteredCustomers = list;
      return;
    }
    this.filteredCustomers = list.filter(c =>
      c.customerName.toLowerCase().includes(query)
    );
  }
  onSelectCustomer(event: any) {
    // console.log(event.value.customerID);
    if (!event?.value) {
      this.selectedCustomerId = -1;
      return;
    }
    // console.log(this.selectedCustomerId)
    this.selectedCustomerId = event.value.customerID;
  }
}
